import { stringify } from 'querystring';

import axios, { setApiContext } from 'utils/axios';
import { populate } from 'utils/strings';
import { getSettings } from 'utils/settings';

import { processResponse } from './functions/response';

let resource;
const getMoralContext = () => getSettings('providers.dynamicore.persona_moral.context');

/**
 * Send request by GET method
 *
 * @param {object} filters
 * @param {boolean} sort
 * @returns
 */
async function get(filters = {}, sort = false, ignoreId = false, isMoralPerson = true) {
  if (isMoralPerson) {
    setApiContext(getMoralContext());
  }
  const qs = stringify(filters);
  const response = await axios.get(qs ? `${resource}?${qs}` : resource);

  return processResponse(response, filters, sort, ignoreId);
  
}

/**
 * Send request by POST method
 *
 * @param {object} payload
 * @returns
 */
async function post(payload, responseAsGet = false, isMoralPerson = true) {
  if (isMoralPerson) {
    setApiContext(getMoralContext());
  }

  const response = await axios.post(resource, payload);
  const { data: { data = [], total = 0 } } = response;

  if (responseAsGet) {
    return {
      values: data,
      total,
    };
  } else {
    const [values] = Array.isArray(data) ? data : [data];
    return values;
  }
}


/**
 * Send request by PUT method
 *
 * @param {object} payload
 * @returns
 */
async function put(payload) {
  setApiContext(getMoralContext());
  const response = await axios.put(resource, payload);
  const { data: { data = [] } } = response;
  const [values] = Array.isArray(data) ? data : [data];

  return values;
}

/**
 * Send request by DELETE method
 *
 * @param {object} filters
 * @param {boolean} inBody
 * @returns
 */
async function del(filters = {}, inBody = false) {
  setApiContext(getMoralContext());
  const qs = stringify(filters);
  const response = inBody
    ? await axios.delete(resource, {
      data: filters,
    })
    : await axios.delete(qs ? `${resource}?${qs}` : resource);
  const { data: { data } } = response;
  const [values] = Array.isArray(data) ? data : [data];

  return values;
}

/**
 *
 * @param {string} service
 * @param {object} params
 * @returns
 */
export const Dynamicore = (service, params = {}) => {
  resource = populate(service, params);

  return {
    get,
    post,
    put,
    delete: del,
  };
};
